import { render, staticRenderFns } from "./show-services.vue?vue&type=template&id=30735694&scoped=true&"
import script from "./show-services.vue?vue&type=script&lang=js&"
export * from "./show-services.vue?vue&type=script&lang=js&"
import style0 from "./show-services.vue?vue&type=style&index=0&id=30735694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30735694",
  null
  
)

export default component.exports